import { AdType, ComponentType } from '@sport1/types/web'
import { AdPlacement } from '@/context/AdPlacementContext/AdPlacementProvider.types'

export interface CreateExtraAdSlot {
    placement: string
    placementId: string
    placements: Map<string | undefined, AdPlacement>
}

export const createExtraAdSlot = ({ placement, placementId, placements }: CreateExtraAdSlot) => {
    if (!placements || !placement || !placementId) return
    if (!placements.has(placementId)) {
        placements.set(placementId, {
            placement,
            placementId,
        })
    }

    return {
        type: ComponentType.AD,
        enrichedWithId: true,
        id: placementId,
        ad: {
            adType: AdType.DISPLAY,
        },
    }
}
